import { z } from "zod";

import { imagesSchema } from "./imagesSchema";
import { trackSchema } from "./trackSchema";

export const selectableGuideSchema = z.object({
  default_guide_id: z.number().nullable(),
  desc: z.string(),
  guide_ids: z.array(z.number()),
  guide_images: z.array(imagesSchema),
  name: z.string(),
  sample_audio_url: z.string().nullable(),
  tagline: z.string(),
  tracks: z.array(trackSchema),
});

export type SelectableGuide = z.infer<typeof selectableGuideSchema>;
